var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 40,
    viewBox: "0 0 52 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 1.77075H1V31.7708H51V1.77075Z",
    stroke: "#FCFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9168 31.979H3.0835V35.104H48.9168V31.979Z",
    stroke: "#FCFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8332 35.104H5.1665V38.229H46.8332V35.104Z",
    stroke: "#FCFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7487 28.0594C30.1886 28.0594 33.7879 23.1072 33.7879 16.9984C33.7879 10.8897 30.1886 5.9375 25.7487 5.9375C21.3088 5.9375 17.7095 10.8897 17.7095 16.9984C17.7095 23.1072 21.3088 28.0594 25.7487 28.0594Z",
    stroke: "#FCFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98454 28.0594H42.0158C42.0158 25.005 44.4059 22.5289 47.3543 22.5289V11.468C44.4059 11.468 42.0158 8.9919 42.0158 5.9375H9.98454C9.98454 8.9919 7.59439 11.468 4.646 11.468V22.5289C7.59439 22.5289 9.98454 25.005 9.98454 28.0594Z",
    stroke: "#FCFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1826 18.5785C13.0151 18.5785 13.69 17.871 13.69 16.9983C13.69 16.1257 13.0151 15.4182 12.1826 15.4182C11.3502 15.4182 10.6753 16.1257 10.6753 16.9983C10.6753 17.871 11.3502 18.5785 12.1826 18.5785Z",
    stroke: "#FCFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8125 18.5785C39.645 18.5785 40.3199 17.871 40.3199 16.9983C40.3199 16.1257 39.645 15.4182 38.8125 15.4182C37.98 15.4182 37.3052 16.1257 37.3052 16.9983C37.3052 17.871 37.98 18.5785 38.8125 18.5785Z",
    stroke: "#FCFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.d7f0c74d080d30ef94bdb215b0ddf5df.svg";
export { ForwardRef as ReactComponent };